import { NavBar } from "./nav-bar";

export type { NavBarProps } from "./nav-bar";

export default NavBar;
